<!-- Settings Sub-Navigation -->
<div class="flex items-center gap-1 mb-6 border-b border-gray-200">
  <button (click)="activeSettingsTab.set('preferences')"
          class="relative px-4 py-2.5 text-sm font-medium transition-all flex items-center gap-2 cursor-pointer"
          [class.text-blue-600]="activeSettingsTab() === 'preferences'"
          [class.text-gray-500]="activeSettingsTab() !== 'preferences'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
    </svg>
    Preferences
    @if (activeSettingsTab() === 'preferences') {
      <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full"></span>
    }
  </button>
  <button (click)="activeSettingsTab.set('integrations')"
          class="relative px-4 py-2.5 text-sm font-medium transition-all flex items-center gap-2 cursor-pointer"
          [class.text-blue-600]="activeSettingsTab() === 'integrations'"
          [class.text-gray-500]="activeSettingsTab() !== 'integrations'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
    </svg>
    Integrations
    @if (activeSettingsTab() === 'integrations') {
      <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full"></span>
    }
  </button>
</div>

<!-- ─── PREFERENCES TAB ─────────────────────────────────────────────────── -->
@if (activeSettingsTab() === 'preferences') {
<div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
  <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/80 flex items-center justify-between">
    <div class="flex items-center gap-3">
      <div class="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center">
        <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
      </div>
      <div>
        <h2 class="text-base font-semibold text-gray-900">Preferences</h2>
        <p class="text-xs text-gray-500">Customize your experience</p>
      </div>
    </div>
    <button (click)="saveSettings()" [disabled]="loadingSettings"
            class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                   text-white bg-blue-600 hover:bg-blue-700
                   disabled:opacity-50 transition-all cursor-pointer
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
      @if(loadingSettings) {
        <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>Saving...</span>
      } @else {
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        <span>Save Settings</span>
      }
    </button>
  </div>
  <div class="p-6 space-y-6">
    <!-- Display Settings Row -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1.5">Default View Mode</label>
        <p class="text-xs text-gray-500 mb-2">Choose how projects are displayed by default</p>
        <div class="relative">
          <select [(ngModel)]="formSettings.displayModeForProject"
                  class="w-full appearance-none border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                         focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                         hover:border-gray-400 transition-colors cursor-pointer bg-white pr-10">
            <option value="LIST">📋 List View</option>
            <option value="GANTT">📊 Gantt Chart</option>
          </select>
          <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1.5">Activity Filter Threshold</label>
        <p class="text-xs text-gray-500 mb-2">Ignore activities shorter than this duration</p>
        <div class="flex items-center gap-3">
          <div class="relative flex-1 max-w-[140px]">
            <input type="number" [(ngModel)]="formSettings.secondsToAvoid" min="0" max="300"
                   class="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-center
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          hover:border-gray-400 transition-colors outline-none">
          </div>
          <span class="text-sm text-gray-500">seconds</span>
        </div>
      </div>
    </div>

    <!-- Default Tenant -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1.5">Agence par défaut</label>
        <p class="text-xs text-gray-500 mb-2">Les projets de cette agence seront affichés en priorité</p>
        <div class="relative">
          <select [(ngModel)]="formSettings.defaultTenantId"
                  class="w-full appearance-none border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                         focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                         hover:border-gray-400 transition-colors cursor-pointer bg-white pr-10">
            <option value="">Aucune (tous les projets)</option>
            @for (tenant of tenants; track tenant.id) {
              <option [value]="tenant.id">{{ tenant.name }}</option>
            }
          </select>
          <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="border-t border-gray-100"></div>

    <!-- AI Settings Section -->
    <div>
      <div class="flex items-start gap-3 mb-3">
        <div class="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
          </svg>
        </div>
        <div class="flex-1">
          <label class="block text-sm font-medium text-gray-700">AI Invoice Prompt</label>
          <p class="text-xs text-gray-500 mt-0.5">
            Customize how AI generates descriptions when logging time entries.
            Use clear instructions about tone, format, and detail level.
          </p>
        </div>
      </div>
      <textarea rows="4" [(ngModel)]="formSettings.aiInvoicePrompt"
                class="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm
                       focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                       hover:border-gray-400 transition-colors outline-none resize-y
                       font-mono text-gray-700 leading-relaxed"
                placeholder="Example: Keep descriptions concise (1-2 sentences). Focus on deliverables and outcomes. Use professional language suitable for client invoices.">
      </textarea>
      <div class="flex items-center justify-between mt-2">
        <p class="text-xs text-gray-400">
          💡 Tip: Be specific about the format and tone you want for invoice descriptions.
        </p>
        <button (click)="resetAiPrompt()" type="button"
                class="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer">
          Reset to default
        </button>
      </div>
    </div>
  </div>
</div>
}

<!-- ─── INTEGRATIONS TAB ─────────────────────────────────────────────────── -->
@if (activeSettingsTab() === 'integrations') {
<div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
  <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/80 flex items-center gap-3">
    <div class="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
      <svg class="w-4 h-4 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z"/>
      </svg>
    </div>
    <div>
      <h2 class="text-base font-semibold text-gray-900">Integrations</h2>
      <p class="text-xs text-gray-500">Manage your third-party connections</p>
    </div>
  </div>
  <div class="p-6">

    <!-- Google Calendar row -->
    <div class="flex items-center justify-between gap-4">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl border border-gray-200 flex items-center justify-center bg-white shadow-sm flex-shrink-0">
          <svg class="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
        </div>
        <div>
          <p class="text-sm font-semibold text-gray-900">Google Calendar</p>
          @if (googleCalendar.connected()) {
            <p class="text-xs text-gray-500">{{ googleCalendar.googleEmail() ?? 'Connected' }}</p>
          } @else {
            <p class="text-xs text-gray-400">Not connected · Events will appear in your activity timeline</p>
          }
        </div>
      </div>

      @if (googleCalendar.connected()) {
      <button (click)="disconnectGoogleCalendar()"
              class="flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium text-red-600
                     bg-red-50 border border-red-200 hover:bg-red-100 transition-all cursor-pointer">
        Disconnect
      </button>
      } @else {
      <button (click)="connectGoogleCalendar()" [disabled]="googleCalendar.connecting()"
              class="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                     text-gray-700 bg-white border border-gray-300 shadow-sm
                     hover:bg-gray-50 hover:border-gray-400
                     disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer">
        @if (googleCalendar.connecting()) {
          <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>Connecting…</span>
        } @else {
          <svg class="w-4 h-4" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Connect Google Calendar</span>
        }
      </button>
      }
    </div>

    <!-- Connected state: badge + calendar list -->
    @if (googleCalendar.connected()) {
    <div class="mt-3">
      <span class="inline-flex items-center gap-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 px-2.5 py-1 rounded-full">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
        @if (googleCalendar.isDemoMode()) { Demo mode active } @else { Calendar sync active }
      </span>
    </div>

    <!-- Calendar list picker -->
    @if (!googleCalendar.isDemoMode()) {
    <div class="mt-4 pt-4 border-t border-gray-100">
      <div class="flex items-center justify-between mb-3">
        <div>
          <p class="text-sm font-medium text-gray-700">Calendars to sync</p>
          <p class="text-xs text-gray-400">Choose which calendars appear in your timeline</p>
        </div>
        @if (loadingCalendars) {
          <svg class="animate-spin w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        } @else if (googleCalendar.calendarList().length === 0) {
          <button (click)="refreshCalendarList()"
                  class="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer">
            Load calendars
          </button>
        } @else {
          <div class="flex items-center gap-3">
            <button (click)="selectAllCalendars()"
                    class="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer">All</button>
            <span class="text-gray-200">|</span>
            <button (click)="selectNoCalendars()"
                    class="text-xs text-gray-500 hover:text-gray-700 font-medium cursor-pointer">None</button>
          </div>
        }
      </div>

      @if (googleCalendar.calendarList().length > 0) {
      <div class="space-y-1">
        @for (cal of googleCalendar.calendarList(); track cal.id) {
        <label class="flex items-center gap-3 p-2.5 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors">
          <span class="w-3 h-3 rounded-full flex-shrink-0 ring-1 ring-black/10"
                [style.background-color]="cal.backgroundColor"></span>
          <span class="flex-1 text-sm text-gray-700 truncate">
            {{ cal.summary }}
            @if (cal.primary) { <span class="text-xs text-gray-400 ml-1">(primary)</span> }
          </span>
          <div class="relative flex-shrink-0">
            <input type="checkbox" class="sr-only peer"
                   [id]="'cal-' + cal.id"
                   [checked]="isCalendarEnabled(cal.id)"
                   (change)="toggleCalendar(cal.id, $any($event.target).checked)">
            <div class="w-9 h-5 rounded-full transition-colors
                        bg-gray-200 peer-checked:bg-blue-500
                        after:content-[''] after:absolute after:top-0.5 after:left-0.5
                        after:w-4 after:h-4 after:rounded-full after:bg-white after:shadow
                        after:transition-transform peer-checked:after:translate-x-4"></div>
          </div>
        </label>
        }
      </div>
      }
    </div>
    }
    }

    <!-- Demo mode toggle -->
    @if (!googleCalendar.connected() || googleCalendar.isDemoMode()) {
    <div class="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
      <div>
        <p class="text-xs font-medium text-gray-600">Demo mode</p>
        <p class="text-xs text-gray-400">Preview calendar overlay with mock events — no GCP needed</p>
      </div>
      <button (click)="toggleDemoMode()"
              [class]="googleCalendar.isDemoMode()
                ? 'px-3 py-1.5 rounded-lg text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 hover:bg-amber-100 transition-all cursor-pointer'
                : 'px-3 py-1.5 rounded-lg text-xs font-medium text-gray-600 bg-gray-50 border border-gray-200 hover:bg-gray-100 transition-all cursor-pointer'">
        {{ googleCalendar.isDemoMode() ? 'Disable demo' : 'Enable demo' }}
      </button>
    </div>
    }

    @if (googleCalendarError) {
    <p class="mt-3 text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{{ googleCalendarError }}</p>
    }
  </div>
</div>
}
